// English translations (default)
const en = {
  // Cover Screen
  cover: {
    title: "Chess Kingdom",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    enter: "ENTER",
    aboutUs: "ABOUT US",
    tagline: "Where legends rise, and every move tells a story",
    selectLanguage: "Select Language"
  },
  
  // Tutorial
  tutorial: {
    skip: "Skip Tutorial",
    previous: "Previous",
    next: "Next",
    finish: "Get Started!",
    quickPlay: {
      title: "Quick Play",
      description: "Jump into a game instantly! Get matched with an AI opponent or practice your skills."
    },
    gameSetup: {
      title: "Game Setup",
      description: "Customize your game settings, choose time controls, and select chess variants."
    },
    multiplayer: {
      title: "Multiplayer",
      description: "Create or join rooms to play with friends. Share room codes for private matches!"
    },
    tournament: {
      title: "Tournaments",
      description: "Compete in tournaments! Choose from Single Elimination, Double Elimination, or Swiss formats."
    },
    ranked: {
      title: "Ranked Matches",
      description: "Test your skills in ranked matches. Climb from Squire to King and earn ELO ratings!"
    },
    skins: {
      title: "Skin Store",
      description: "Customize your chess pieces and boards. Free skins available, plus premium options!"
    },
    friends: {
      title: "Friends & Chat",
      description: "Add friends, chat with them, and invite them to games directly!"
    },
    settings: {
      title: "Settings",
      description: "Adjust game preferences, sound settings, and customize your experience."
    }
  },
  
  // Authentication
  auth: {
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    username: "Username",
    forgotPassword: "Forgot Password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signUp: "Sign Up",
    signIn: "Sign In",
    orContinueWith: "Or continue with",
    guest: "Play as Guest",
    logout: "Logout"
  },
  
  // Terms of Service
  terms: {
    title: "Terms of Service & Code of Conduct",
    subtitle: "Please read and accept our Terms of Service, Code of Conduct, and Parent/Guardian Safety Notice to continue.",
    scrollToRead: "Scroll down to read all terms",
    readComplete: "You have read all terms",
    iAgree: "I Agree",
    mustAccept: "You must accept the Terms of Service to create an account.",
    versionMismatch: "Terms version mismatch. Please refresh and accept the current Terms.",
    viewAccepted: "View Accepted Terms",
    acceptedOn: "Accepted on",
    version: "Version",
    legalAgreements: "Legal Agreements",
    termsHistory: "Terms Acceptance History",
    noHistory: "No terms acceptance history found.",
    viewTermsText: "View Terms",
    viewingIn: "Viewing in"
  },
  
  // Lobby
  lobby: {
    title: "KING'S COURT",
    subtitleRise: "Rise of the",
    subtitleDukes: "Dukes",
    quickPlay: "QUICK PLAY",
    createRoom: "CREATE ROOM",
    joinRoom: "JOIN ROOM",
    settings: "Settings",
    skins: "SKINS",
    friends: "Friends",
    chat: "Chat",
    spectate: "SPECTATE",
    roomCode: "Room Code",
    enterRoomCode: "Enter room code...",
    join: "Join",
    create: "Create",
    private: "Private",
    public: "Public",
    players: "Players",
    waiting: "Waiting for opponent...",
    ready: "Ready",
    start: "Start Game",
    gameSetup: "GAME SETUP",
    chooseVariant: "Choose Variant & Mode",
    multiplayer: "MULTIPLAYER",
    onlineMatches: "Online Matches",
    profile: "Profile",
    messages: "Messages",
    assistant: "Assistant",
    help: "Help",
    exit: "Exit"
  },
  
  // Game
  game: {
    white: "White",
    black: "Black",
    whiteToMove: "White To Move",
    blackToMove: "Black To Move",
    check: "Check!",
    checkmate: "Checkmate!",
    stalemate: "Stalemate!",
    draw: "Draw",
    resign: "Resign",
    resigns: "Resigns",
    forfeits: "Forfeits",
    offerDraw: "Offer Draw",
    acceptDraw: "Accept Draw",
    declineDraw: "Decline Draw",
    newGame: "New Game",
    leave: "Leave",
    rules: "RULES",
    moveHistory: "Move History",
    noMovesYet: "No moves yet",
    movesWillAppear: "Moves will appear here as you play",
    yourTurn: "Your Turn",
    opponentTurn: "Opponent's Turn",
    gameOver: "Game Over",
    youWin: "YOU WIN!",
    youLose: "You Lost",
    whiteWins: "White Wins!",
    blackWins: "Black Wins!",
    drawGame: "It's a Draw!",
    playAgain: "Play Again",
    backToLobby: "Back to Lobby",
    classic: "CLASSIC",
    kingsCourt: "KING'S COURT",
    fightToBeKing: "Fight To Be King",
    kingCaptured: "King Captured!",
    winner: "Winner",
    rematch: "Rematch",
    decline: "Decline",
    waiting: "Waiting...",
    acceptRematch: "Accept Rematch",
    wantsRematch: "wants a rematch!",
    rematchAccepted: "Rematch accepted! Starting new game...",
    rematchDeclined: "Rematch declined. Returning to lobby...",
    waitingForOpponent: "Waiting for opponent...",
    startingNewGame: "Starting new game...",
    continue: "Continue"
  },
  
  // Settings
  settings: {
    title: "Settings",
    boardCustomization: "Board & Piece Customization",
    livePreview: "Live Preview",
    previewDescription: "See how your customization looks",
    boardTheme: "Board Colors",
    pieceTheme: "Piece Colors",
    customColors: "Custom Colors",
    presetThemes: "Preset Themes",
    lightSquares: "Light Squares",
    darkSquares: "Dark Squares",
    whitePieces: "White Pieces",
    blackPieces: "Black Pieces",
    coordinateColor: "Coordinate Color",
    coordinateDescription: "Customize the color of rank numbers (1-8) and file letters (a-h)",
    chessPieceSkins: "Chess Piece Skins",
    chessPieceSkinsDescription: "Replace standard pieces with premium 3D rendered skins",
    dukeSkins: "Duke Skins",
    dukeSkinsDescription: "Choose Duke skins for each side - board theme auto-matches!",
    whiteSideDuke: "White Side Duke",
    blackSideDuke: "Black Side Duke",
    autoMatchBoard: "Auto-match board colors to Duke skin",
    saveAndClose: "Save & Close",
    reset: "Reset to Default",
    close: "Close",
    premium: "Premium",
    default: "Default",
    classic: "Classic",
    viewMode: "View Mode",
    viewModeDescription: "Choose how you want to view the chess board",
    topDown: "Top-Down",
    topDownDescription: "Flat, straight-down view like traditional boards",
    perspective3D: "3D Perspective",
    perspective3DDescription: "Classic 2D pieces with dynamic 3D board angle",
    skinsApplyTo: "Skins apply to King, Queen, Rook, Bishop, Knight, Pawn",
    dukeHint: "Left: Instant King · Right: Fight to be King"
  },
  
  // Skin Store
  store: {
    title: "Skin Store",
    subtitle: "Premium chess piece skins, duke shields & themed sets",
    chessPieces: "Chess Pieces",
    dukeSkins: "Duke Skins",
    themedSets: "Themed Sets",
    pieceSkins: "Piece Skins",
    allPiecesBundle: "All Piece Skins Bundle",
    allDukeBundle: "All Duke Skins Bundle",
    bundleDiscount: "Get all premium skins at 30% off!",
    owned: "Owned",
    equip: "Equip",
    equipped: "Equipped",
    buy: "Buy",
    preview: "Preview",
    processing: "Processing...",
    free: "Free",
    rare: "Rare",
    epic: "Epic",
    legendary: "Legendary",
    common: "Common",
    securePayment: "One-time purchase • Use forever • Secure payment via Stripe",
    loginToPurchase: "Please login to purchase skins",
    themeEquipped: "theme equipped!",
    themeSelected: "theme selected! Purchase to unlock.",
    completePacks: "Complete Theme Packs",
    completePacksDesc: "Get matching pieces, dukes, and board themes at a discount!",
    categories: {
      all: "All",
      free: "Free",
      white: "White",
      black: "Black",
      neutral: "Neutral",
      premium: "3D Premium",
      vintage: "Vintage",
      kawaii: "Kawaii",
      fable: "Fable",
      gothic: "Gothic",
      colossal: "Colossal",
      gemstone: "Gemstone",
      kingdom: "Kingdom"
    },
    includes: "Includes",
    pieces: "pieces",
    dukes: "dukes"
  },
  
  // Chat
  chat: {
    title: "Chat",
    lobbyChat: "Lobby Chat",
    gameChat: "Game Chat",
    typeMessage: "Type a message...",
    send: "Send",
    spectatorChat: "Spectator Chat",
    playerChat: "Player Chat"
  },
  
  // Friends
  friends: {
    title: "Friends",
    online: "Online",
    offline: "Offline",
    addFriend: "Add Friend",
    removeFriend: "Remove",
    invite: "Invite",
    pending: "Pending",
    accept: "Accept",
    decline: "Decline",
    friendRequests: "Friend Requests",
    noFriends: "No friends yet",
    searchPlayers: "Search players..."
  },
  
  // Notifications
  notifications: {
    friendRequest: "sent you a friend request",
    gameInvite: "invited you to play",
    yourTurn: "It's your turn!",
    opponentJoined: "Opponent joined the game",
    opponentLeft: "Opponent left the game",
    drawOffered: "Opponent offered a draw",
    connected: "Connected to server",
    disconnected: "Disconnected from server",
    reconnecting: "Reconnecting..."
  },
  
  // Errors
  errors: {
    invalidEmail: "Invalid email address",
    invalidPassword: "Password must be at least 6 characters",
    passwordMismatch: "Passwords do not match",
    loginFailed: "Login failed. Please check your credentials.",
    registerFailed: "Registration failed. Please try again.",
    connectionError: "Connection error. Please try again.",
    connectionErrorInternet: "Connection error. Please check your internet.",
    offlineError: "You appear to be offline. Please check your internet connection and try again.",
    networkError: "Unable to connect to server. Please reload the page and try again.",
    gameNotFound: "Game not found",
    roomFull: "Room is full",
    invalidMove: "Invalid move",
    // Auth errors
    pleaseEnterName: "Please enter your name",
    completeBothSecurityQuestions: "Please complete both security questions or leave them all empty",
    selectDifferentQuestions: "Please select different security questions",
    unexpectedError: "An unexpected error occurred",
    failedToSendResetCode: "Failed to send reset code",
    invalidOrExpiredCode: "Invalid or expired reset code",
    failedToResetPassword: "Failed to reset password. Please try again.",
    // Room errors
    pleaseEnterRoomName: "Please enter a room name",
    pleaseEnterRoomCode: "Please enter a room code",
    roomCodeMustBe6Chars: "Room code must be 6 characters",
    roomNotFound: "Room not found. Check the code.",
    roomRequiresApproval: "This room requires host approval. Request to rejoin from your joined rooms list.",
    failedToCreateRoom: "Failed to create room",
    failedToJoinRoom: "Failed to join room",
    failedToLeaveRoom: "Failed to leave room",
    failedToRemoveRoom: "Failed to remove room",
    failedToLoadGames: "Failed to load games",
    failedToRequestRejoin: "Failed to request rejoin",
    // Matchmaking errors
    failedToJoinMatchmaking: "Failed to join matchmaking",
    noOpponentFound: "No opponent found. Please try again later or try a different game mode.",
    // Friends errors
    searchFailed: "Search failed",
    failedToSendRequest: "Failed to send request",
    failedToAcceptRequest: "Failed to accept request",
    failedToRejectRequest: "Failed to reject request",
    failedToCancelRequest: "Failed to cancel request",
    failedToRemoveFriend: "Failed to remove friend"
  },
  
  // Success Messages
  success: {
    copiedToClipboard: "Copied to clipboard!",
    rejoinRequestSent: "Rejoin request sent to host!",
    joinRequestSent: "Your join request has been sent to the room host. Please wait for approval.",
    roomRemovedFromList: "Room removed from your list.",
    leftRoomSuccessfully: "Left room successfully",
    requestRejected: "Request rejected",
    requestCancelled: "Request cancelled",
    friendRemoved: "Friend removed",
    // Tournament success
    tournamentCreated: "Tournament created successfully!",
    tournamentJoined: "Successfully joined tournament!",
    tournamentLeft: "Left tournament successfully",
    tournamentStarted: "Tournament started!",
    tournamentCancelled: "Tournament cancelled",
    tournamentsCleared: "All tournaments cleared",
    removedFromHistory: "Removed from history"
  },
  
  // Tournament translations
  tournament: {
    title: "Tournaments",
    createTournament: "Create Tournament",
    joinTournament: "Join Tournament",
    leaveTournament: "Leave Tournament",
    startTournament: "Start Tournament",
    cancelTournament: "Cancel Tournament",
    clearAll: "Clear All",
    myTournaments: "My Tournaments",
    availableTournaments: "Available Tournaments",
    tournamentHistory: "Tournament History",
    bracket: "Bracket",
    participants: "Participants",
    status: "Status",
    waiting: "Waiting",
    inProgress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    format: "Format",
    singleElimination: "Single Elimination",
    doubleElimination: "Double Elimination",
    swiss: "Swiss",
    round: "Round",
    match: "Match",
    ready: "Ready",
    notReady: "Not Ready",
    markReady: "Mark Ready",
    winner: "Winner",
    loser: "Loser",
    bye: "Bye",
    // Errors
    pleaseLoginToCreate: "Please log in to create a tournament",
    pleaseLoginToJoin: "Please log in to join a tournament",
    failedToLoadTournaments: "Failed to load tournaments",
    failedToCreateTournament: "Failed to create tournament",
    failedToJoinTournament: "Failed to join tournament",
    failedToLeaveTournament: "Failed to leave tournament",
    failedToStartTournament: "Failed to start tournament",
    failedToCancelTournament: "Failed to cancel tournament",
    failedToClearTournaments: "Failed to clear tournaments",
    failedToRemoveFromHistory: "Failed to remove from history",
    failedToLoadTournament: "Failed to load tournament",
    failedToMarkReady: "Failed to mark as ready"
  },
  
  // Ranked matchmaking translations
  ranked: {
    title: "Ranked Matchmaking",
    findMatch: "Find Ranked Match",
    inQueue: "In Queue...",
    leaveQueue: "Leave Queue",
    yourRank: "Your Rank",
    elo: "ELO",
    tier: "Tier",
    wins: "Wins",
    losses: "Losses",
    draws: "Draws",
    season: "Season",
    leaderboard: "Leaderboard",
    // Tiers
    squire: "Squire",
    knight: "Knight",
    baron: "Baron",
    duke: "Duke",
    king: "King",
    // Errors
    pleaseLoginToPlay: "Please log in to play ranked",
    failedToJoinQueue: "Failed to join queue"
  },
  
  // Misc
  misc: {
    loading: "Loading...",
    cancel: "Cancel",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    ok: "OK",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    all: "All",
    none: "None",
    select: "Select",
    selected: "Selected"
  },
  
  // About Us Page
  aboutUs: {
    back: "← Back",
    title: "Welcome to Chess Kingdom: King's Court",
    subtitle: "Where legends rise, and every move tells a story.",
    description: "Step into a realm where classic strategy meets mythic scale. King's Court is more than a game mode—it's a proving ground for tacticians, dreamers, and champions alike. Whether you're a grandmaster seeking fresh challenge or a newcomer drawn to the thrill of conquest, this is your arena. ⚔️",
    keyFeatures: "Key Features",
    feature1Title: "Dynamic Variants",
    feature1Desc: "Explore evolving rule sets and board layouts that test your adaptability and foresight.",
    feature2Title: "Courtly Progression",
    feature2Desc: "Earn titles, unlock emblems, and ascend through a richly layered ranking system that rewards mastery and flair.",
    feature3Title: "Skill-Driven Play",
    feature3Desc: "Transparent feedback, telemetry-tuned balance, and fair matchmaking ensure every victory feels earned.",
    feature4Title: "Live Chat & Lore Threads",
    feature4Desc: "Connect with rivals and allies, uncover procedural lore, and shape the mythos of your kingdom.",
    feature5Title: "Built for Pros",
    feature5Desc: "Precision tuning, replay analysis, and tournament-ready infrastructure make King's Court a serious platform for competitive play.",
    closingStatement: "Whether you seek glory, growth, or grand strategy, King's Court invites you to rule with wisdom, fight with honor, and leave your mark on the realm.",
    developmentNotice: "Note: The Game is still under development, and with your patience and support, the game will become a home away from home. Have Fun, make friends and alliances, because when I am done, your strategic methods of winning will be tested…. Welcome to your Kingdom….",
    contactTitle: "More info or suggestions Contact:",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Rules
  rules: {
    title: "Game Rules",
    classic: "Classic Chess",
    classicDesc: "Standard chess rules - checkmate the opponent's king to win.",
    instantKing: "Instant King",
    instantKingDesc: "Capture the enemy king directly to win - no checkmate needed!",
    fightToBeKing: "Fight to be King",
    fightToBeKingDesc: "Your promoted pawn becomes the new king! Protect it or lose the game.",
    timerRules: "Timer Rules",
    timerDesc: "Each player has limited time per move. If time runs out, your turn is skipped."
  },
  
  // Assistant
  assistant: {
    title: "Chess Kingdom Assistant",
    searchPlaceholder: "Search help topics...",
    randomTip: "Show me a random tip",
    noResults: "No help topics found for",
    noResultsHint: "Try different keywords or browse categories above",
    // Categories
    categories: {
      gettingStarted: "Getting Started",
      dukeMechanics: "Duke Mechanics",
      multiplayer: "Multiplayer",
      customization: "Customization & Skins",
      boardFeatures: "Board Features",
      skinStore: "Skin Store",
      trialPayments: "Trial & Payments",
      strategyTips: "Strategy Tips",
      troubleshooting: "Troubleshooting"
    },
    // Getting Started
    gettingStarted: {
      q1: "How do I start playing?",
      a1: "Click 'Solo Play' to play against AI, or 'Multiplayer' to play with other players. You can play as a guest or sign up for a free 48-hour trial to unlock all variants.",
      q2: "What are the different game variants?",
      a2: "Chess Kingdom offers 7 variants: Standard Chess, Instant King, Fight to be King, Player's Choice, Pawn's Wild, Chess Kingdom (Two Dukes), and Handicap Mode. Each has unique rules involving the Duke piece.",
      q3: "How do I customize the board?",
      a3: "Click the Settings button to access customization options. You can change board colors, piece skins, duke skins, board themes, coordinates color, view mode (3D or Top-Down), and board size (80%-120%).",
      q4: "How do I flip the board view?",
      a4: "Click the flip button in the game header to view the board from Black's perspective. The coordinates will also update to match the flipped view.",
      q5: "How do I resize the board?",
      a5: "Go to Settings → Board Size. Use the slider or click 'Compact' (85%), 'Default' (100%), or 'Large' (115%) presets."
    },
    // Duke Mechanics
    dukeMechanics: {
      q1: "What is the Duke piece?",
      a1: "The Duke is a special piece that replaces one Bishop. It moves diagonally (1 square) for non-capturing moves, but can capture in ALL 8 directions (adjacent squares only). It's marked with a shield icon.",
      q2: "What happens when my King is captured?",
      a2: "Your Duke transforms into a new King! The transformation rules depend on your embodiment mode: Instant King (immediate transformation) or Fight to be King (must reach baseline first).",
      q3: "How does Fight to be King work?",
      a3: "After your King is captured, your Duke must return to its starting baseline (rank 1 for White, rank 8 for Black) to transform into a King. Until then, you have no King!",
      q4: "Can Duke pieces be promoted?",
      a4: "Only in Pawn's Wild variant! When a pawn reaches the end rank, you can promote it to Queen, Rook, Bishop, Knight, or Duke.",
      q5: "What's the difference between Instant King and Fight to be King skins?",
      a5: "Duke skins come in two variants: The 'Instant King' version appears during normal play, while 'Fight to be King' version appears when your Duke is fighting to reach baseline after King capture."
    },
    // Multiplayer
    multiplayer: {
      q1: "How does Quick Match work?",
      a1: "Quick Match pairs you with another player instantly! Select your preferred game mode, click 'Find Match', and you'll be matched with someone who chose the same mode.",
      q2: "How do I create and manage private rooms?",
      a2: "Go to 'Create Room' tab, enter a room name, choose game variant, set spectator settings, and share the 6-char code with friends. Your rooms appear in 'My Rooms' section.",
      q3: "How do I join a friend's room?",
      a3: "Go to 'Join Room' tab, enter the 6-character code your friend shared, and click 'Join Room'. Rooms you've joined appear in 'Joined Rooms' section.",
      q4: "What are the spectator settings?",
      a4: "Private: No spectators allowed. Request to Join: Spectators must request approval. Open: Anyone can watch freely. Great for tournaments or teaching!",
      q5: "How do I watch games as a spectator?",
      a5: "Go to 'Spectate' tab to see all public games. Filter by game type to find specific variants. Click 'Watch' for open games or 'Request' for request-only games.",
      q6: "Can I chat during games?",
      a6: "Yes! During multiplayer games, use the in-game chat. Messages are automatically translated if players speak different languages!",
      q7: "Does my theme sync to opponents?",
      a7: "Yes! If you're the host (room creator), your board theme, piece skins, and duke skins automatically sync to all players in your game."
    },
    // Customization
    customization: {
      q1: "What piece skins are available?",
      a1: "We have 20+ piece skin sets: Golden 3D, Obsidian 3D, Vintage, Kawaii, Fable, Gothic, Colossal, Amethyst Purple, Sapphire Blue, Stone & Sand Kingdom, Woodlin Warriors Kingdom, and more!",
      q2: "What duke skins are available?",
      a2: "Over 50 duke skins in categories: Metallic (Gold, Silver), Color (Purple, Blue, Emerald), White (Spartan, Eagle), Black (Steel, Crown), Gemstone, Kingdom, 3D Premium, and more!",
      q3: "How do I change piece skins?",
      a3: "Settings → Piece Skins section. You can set different skins for White and Black sides separately! Use 'Preview Both Sides' to see how they'll look together.",
      q4: "How do I change duke skins?",
      a4: "Settings → Duke Skins section. Select skins categorized by White, Black, or Neutral. Each duke has both Instant King and Fight to be King variants.",
      q5: "What are Theme Packs?",
      a5: "Theme Packs bundle piece skins, duke skins, and board themes together! Available packs include Royal Gold, Dark Knight, Vintage Classic, and Kingdom Battle packs!",
      q6: "How do I get a random theme?",
      a6: "Click 'Random Theme Pack' to apply a random complete theme, or 'Random Kingdom Battle' for a random cross-faction matchup.",
      q7: "Can I customize coordinate colors?",
      a7: "Yes! Settings → Coordinate Color. Pick any color for the rank numbers (1-8) and file letters (a-h) on the board."
    },
    // Board Features
    boardFeatures: {
      q1: "What are the view modes?",
      a1: "Two view modes: 3D Perspective (with depth and shadows) and Top-Down (flat, traditional). Toggle in Settings → View Mode.",
      q2: "How does board sizing work?",
      a2: "Settings → Board Size lets you scale the board from 80% (Compact) to 120% (Large). Default is 100%.",
      q3: "What board themes are available?",
      a3: "Multiple board color themes: Classic Wood, Royal Gold, Dark Knight, Ocean Blue, Forest Green, Stone Gray, and more.",
      q4: "How do coordinates work?",
      a4: "Coordinates show rank numbers (1-8) and file letters (a-h) on the board edges. They flip correctly when using the board flip button!",
      q5: "Does the board work on mobile?",
      a5: "Yes! The board is fully responsive. In landscape mode, the board auto-sizes to fit the screen height."
    },
    // Skin Store
    skinStore: {
      q1: "How do I access the Skin Store?",
      a1: "Click the Store button from the lobby, or access it through Settings → 'Visit Store' button. The store has three tabs: Themed Sets, Piece Skins, and Duke Skins.",
      q2: "What are Themed Sets?",
      a2: "Complete theme packages at a discount! They include matching piece skins, duke skins, and board themes.",
      q3: "Are there bundle discounts?",
      a3: "Yes! 'All Piece Skins Bundle' and 'All Duke Skins Bundle' get you all skins at 40% off. Themed Sets also offer bundle pricing!",
      q4: "How do skin rarities work?",
      a4: "Common (gray): Free or basic. Rare (blue): $1.99-2.49. Epic (purple): $2.49-3.99. Legendary (gold): $3.49-4.99.",
      q5: "Can I preview skins before buying?",
      a5: "Yes! Hover over any skin card to see a preview. Piece skins show King, Queen, and Knight.",
      q6: "How do I equip purchased skins?",
      a6: "In the Store, owned skins show 'Equip' button instead of price. Click Equip to apply immediately."
    },
    // Trial & Payments
    trialPayments: {
      q1: "What is the 48-hour free trial?",
      a1: "New users get 48 hours of free access to ALL game variants. After the trial ends, Standard Chess and Instant King remain free.",
      q2: "How much do variants cost?",
      a2: "Fight to be King & Handicap Mode: $2.99, Player's Choice: $3.99, Pawn's Wild & Two Dukes: $4.99. Or get the All Variants Bundle for $8.99!",
      q3: "How much do skins cost?",
      a3: "Individual skins: $1.99-$4.99 depending on rarity. Bundles: ~40% off. Themed Sets: $8.99-$12.99.",
      q4: "Can I play as a guest?",
      a4: "Yes! Guest mode allows immediate play without signing up. However, game history won't be saved.",
      q5: "How do payments work?",
      a5: "All payments are securely processed through Stripe. One-time purchases unlock content forever. No subscriptions required."
    },
    // Strategy Tips
    strategyTips: {
      q1: "Duke opening strategy?",
      a1: "Position your Duke to control center diagonals early. Its unique 8-direction capture ability makes it excellent for threatening multiple pieces.",
      q2: "When to choose Instant King vs Fight to be King?",
      a2: "Choose Instant King if your Duke is well-positioned. Choose Fight to be King if your Duke is already near baseline.",
      q3: "Two Dukes variant strategy?",
      a3: "Protect both Dukes carefully - they're your 'extra lives'! When your King is captured, choose the safer Duke for transformation.",
      q4: "Pawn's Wild endgame?",
      a4: "Consider promoting pawns to Dukes for 'King insurance' - if your King gets captured later, a promoted Duke can become your new King!",
      q5: "Using the board flip strategically?",
      a5: "Flip the board to see positions from your opponent's perspective! This helps identify threats you might miss."
    },
    // Troubleshooting
    troubleshooting: {
      q1: "Game is loading slowly",
      a1: "Try the Troubleshooter button to run diagnostics. Check your internet connection. Try refreshing the page (Ctrl+F5).",
      q2: "Multiplayer not connecting",
      a2: "Use the Troubleshooter to check WebSocket connection status. Ensure you're logged in. Check for firewall/VPN issues.",
      q3: "Settings not saving",
      a3: "Settings use localStorage. Check if your browser allows it. Try the Troubleshooter's 'Reset Settings' option.",
      q4: "Where is the move history?",
      a4: "Move history sidebar appears on the RIGHT side during active games. Requires browser width > 768px.",
      q5: "Board size slider not working?",
      a5: "Try: 1) Refresh the page. 2) Clear browser cache. 3) Check if you're in a game. 4) Try different view mode.",
      q6: "Pieces look too small/large?",
      a6: "Different piece skins have different optimal sizes. Go to Settings → Board Size to adjust.",
      q7: "Forgot my password?",
      a7: "Go to Account page → 'Forgot Password?' → Answer your security questions → Password sent to your email.",
      q8: "How do I contact support?",
      a8: "Use the Troubleshooter for technical issues. For billing/account issues, email support from the Account page."
    },
    // Tips
    tips: {
      tip1: "The Duke can capture in 8 directions but only moves diagonally when not capturing!",
      tip2: "In Fight to be King mode, your Duke must reach the baseline to transform.",
      tip3: "Position your Duke to control multiple squares - its unique movement is powerful!",
      tip4: "In Two Dukes variant, protecting both Dukes gives you more comeback options.",
      tip5: "In Pawn's Wild, promoting to Duke gives you 'King insurance' if captured.",
      tip6: "Quick Match: Select the same game mode as your opponent to get matched instantly!",
      tip7: "Created rooms show in 'My Rooms', joined rooms show in 'Joined Rooms'.",
      tip8: "Set your room to 'Open' to let anyone watch your epic games!",
      tip9: "Request Mode: Players must approve spectators - perfect for private teaching.",
      tip10: "You can create max 5 rooms. Cancel or complete them to create more!",
      tip11: "Click the Settings button to change board and piece colors anytime.",
      tip12: "All your moves are logged in the sidebar on the right side of the screen.",
      tip13: "Messages are auto-translated for players speaking different languages!",
      tip14: "Each private room gets a unique 6-character code to share with friends.",
      tip15: "Theme Packs: Get matching pieces, dukes, and board themes in one click!",
      tip16: "Try Stone & Sand vs Woodlin Warriors for epic faction warfare!",
      tip17: "Let the game pick a random theme for you - discover new favorites!",
      tip18: "Amethyst Purple and Sapphire Blue make your pieces shine!",
      tip19: "Click the flip button to view from Black's perspective - great for analysis!",
      tip20: "Rotate your device for a larger board view on mobile!",
      tip21: "Use the slider in Settings to scale the board from 80% to 120%!",
      tip22: "The Colossal sets feature epic marble and bronze sculpted pieces!",
      tip23: "Four cute Kawaii emoji piece sets - Brown, White, Black, and Beige!",
      tip24: "Gothic White and Black sets feature intricate dark fantasy designs!",
      tip25: "Fable Medieval: Crusader knights vs dark warriors - epic battle pieces!"
    }
  },

  // Account Manager
  account: {
    title: "Account Management",
    accountInfo: "Account Information",
    usernameEmail: "Username/Email",
    displayName: "Display Name",
    accountType: "Account Type",
    userId: "User ID",
    guest: "Guest",
    registered: "Registered",
    notAvailable: "N/A",
    // Notifications
    notificationSettings: "Notification Settings",
    notificationSound: "Notification Sound",
    notificationSoundDesc: "Play a chime when you receive notifications",
    // Security
    security: "Security",
    passwordManagement: "Password Management",
    passwordNote: "For security reasons, we don't display passwords. If you need to reset your password, please use the 'Forgot Password' feature.",
    forgotPassword: "Forgot Password?",
    passwordRecovery: "Password Recovery",
    passwordRecoveryHelp: "Answer your security questions to receive your password via email",
    securityQuestion1: "Security Question 1",
    securityQuestion2: "Security Question 2",
    selectQuestion: "Select a question...",
    yourAnswer: "Your answer",
    sendPasswordEmail: "Send Password to Email",
    // Security Questions
    securityQuestions: {
      q1: "What was the name of your first pet?",
      q2: "What city were you born in?",
      q3: "What is your mother's maiden name?",
      q4: "What was the name of your elementary school?",
      q5: "What is your favorite book?",
      q6: "What was your childhood nickname?",
      q7: "What is the name of your favorite teacher?",
      q8: "What street did you grow up on?"
    },
    // Danger Zone
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    deleteAccountDesc: "Permanently delete your account and all associated data.",
    deleteWarning: "This will permanently delete:",
    deleteWarningItems: {
      account: "Your account and profile",
      gameHistory: "All game history",
      friends: "Friend connections",
      purchases: "Purchased variants",
      settings: "Settings and preferences"
    },
    typeDelete: "Type DELETE to confirm:",
    typeDeletePlaceholder: "Type DELETE here",
    deleteForever: "Delete My Account Forever",
    // Messages
    deleteConfirmTitle: "Are you absolutely sure?",
    deleteConfirmMsg: "This action cannot be undone.",
    deleteSuccess: "Account deleted successfully. You will be logged out.",
    deleteFailed: "Failed to delete account",
    passwordResetSuccess: "Password reset successful! Your password has been sent to your email address. Please check your inbox (and spam folder).",
    securityAnswersIncorrect: "Security answers incorrect. Please try again.",
    passwordResetFailed: "Failed to reset password. Please try again.",
    answerBothQuestions: "Please answer both security questions"
  },
  // Per-event notification settings
  notificationSettings: {
    title: "Push Notifications",
    browserNotifications: "Browser Notifications",
    enabled: "Enabled",
    blocked: "Blocked",
    notSet: "Not Set",
    enablePrompt: "Enable push notifications to get alerts when:",
    promptTurn: "It's your turn to move",
    promptMatch: "A match is found",
    promptFriend: "You receive friend requests",
    promptMessages: "You get new messages",
    enableButton: "Enable Notifications",
    permissionDeniedAlert: "Notifications were blocked. Please enable them in your browser settings.",
    blockedMessage: "Notifications are blocked by your browser.",
    blockedHelp: "To enable them, click the lock/info icon in your browser's address bar and allow notifications for this site.",
    sounds: "Notification Sounds",
    soundsDesc: "Play sounds for important events like your turn",
    sent: "Sent!",
    testButton: "Test Notification",
    eventPreferences: "Event Preferences",
    eventPreferencesDesc: "Choose which events you want to be notified about",
    yourTurn: "Your Turn",
    yourTurnDesc: "When it's your turn to move",
    gameInvites: "Game Invites",
    gameInvitesDesc: "When a match is found or you receive invites",
    friendRequests: "Friend Requests",
    friendRequestsDesc: "When someone sends you a friend request",
    messages: "Messages",
    messagesDesc: "When you receive chat messages",
    spectatorRequests: "Spectator Requests",
    spectatorRequestsDesc: "When someone wants to watch your game",
    tournaments: "Tournaments",
    tournamentsDesc: "Upcoming tournament reminders and updates",
    alwaysOn: "Always on for best experience",
    alwaysOnLabel: "Always On"
  }
};

export default en;
